import styled from 'styled-components';
import VIcon from '../commons/Icons/VIcon';
import { AnchorButton, Icon, TooltipProps, Navbar } from '@blueprintjs/core';

import { ReactComponent as Lifesaver } from '../../../assets/images/symbols/lifesaver.svg';
import Tooltip from '../commons/Basic/Tooltip/Tooltip';

export const MenuLogo = styled.div`
  display: flex;
  align-content: flex-start;
  justify-content: center;
  cursor: pointer;
`;

type SideOpenProps = {
  close: boolean;
};

export const SideOpen = styled.div`
  position: absolute;
  transition: 0.3s;
  width: 33px;
  height: 100%;
  z-index: 122;
  left: -30px;

  &:hover {
    left: ${(props: SideOpenProps) => (props.close ? '-4px' : '0px')};
  }
`;

export const IconSidebar = styled(VIcon)`
  color: #fff;

  & svg {
    fill: #fff;
  }
`;

interface ICSidebar {
  collapse: boolean;
  background: string;
}

export const CSidebar = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: ${(props: ICSidebar) => (props.collapse ? 1 : 5)}px;
  background-color: ${(props: ICSidebar) => props.background};
  box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.09);
  color: #fff;
  min-height: 100%;
  width: ${(props: ICSidebar) => (props.collapse ? 80 : 220)}px !important;
  transition: width ease-in 120ms;

  @media (min-width: 993px) {
    width: 190px;
  }
`;

type ShowImgOrgType = {
  imgOrg: string;
  isCollapse: boolean;
};

export const ShowImgOrg = styled.div`
  background-image: url(${(props: ShowImgOrgType) => props.imgOrg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  transition: all ease-in 120ms;
  width: 100%;
  height: ${(props: ShowImgOrgType) => (!props.isCollapse ? 5.7 : 1.8)}em;
  border-radius: 50%;
`;

export const MenuContainer = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  .root-sub-menu > div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .root-item-menu {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const MenuCommodityContainer = styled(MenuContainer)`
  flex: unset;
  .rc-menu-submenu-title {
    padding-left: 12px !important;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  align-self: flex-end;
  width: 100%;
  margin-bottom: 10px;
  margin-top: 0;
`;

export const LogoImg = styled.div<{ isMobileRes: boolean }>`
  justify-content: center;
  margin-bottom: 5px;
  padding-top: ${({ isMobileRes }) => (isMobileRes ? 2.5 : 0)}rem;
  @media screen and (min-width: 1367px) {
    margin-bottom: 15px;
  }
`;

export const Img = styled.img`
  height: 2.1em;
  margin-top: 5px;
  @media screen and (min-width: 1367px) {
    height: 2.4em;
  }
`;

export const RingImg = styled.div`
  width: ${(props: { isCollapse: boolean }) => (!props.isCollapse ? 95 : 34)}px;
  background-color: transparent;
  border-radius: 50%;
  border: 3px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

interface ILifeSaverTooltip extends TooltipProps {
  isCollapse: boolean;
}

export const LifeSaverTooltip = styled(Tooltip)`
  position: absolute;
  bottom: ${(props: ILifeSaverTooltip) => (props.isCollapse ? '-10px' : '0')};
  right: ${(props: ILifeSaverTooltip) => (props.isCollapse ? '-10px' : '0')};
`;
export const LifeSaver = styled(Lifesaver)`
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 3px 1px #474747;
  border: 2px solid #cfcfcf2e;
  cursor: pointer;
  &:focus {
    outline: unset;
    outline-offset: unset;
  }
  &:active {
    transform: translateY(1px);
  }
`;

type PinUnPinProps = {
  open: boolean;
};

export const PinUnPin = styled.div`
  margin-bottom: 2px;
  position: ${(props: PinUnPinProps) => (props.open ? 'absolute' : 'static')};
  right: 0;
  & > span {
    margin-right: 0 !important;
  }
  @media screen and (min-width: 1367px) {
    margin-bottom: 6px;
  }
`;

export const CSidebarPushable = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: start;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  @media (max-width: 768px) {
    height: calc(100% - 46px);
  }
  min-height: 404px;
`;

export const CSidebarPusher = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;
  @media (max-width: 992px) {
    width: calc(100% - 75px);
  }
  @media (min-width: 993px) {
    width: calc(100% - 120px);
  }
`;

interface IContainer {
  background: string;
}

export const Container = styled.div`
  padding-top: ${process.env.REACT_APP_DS === 'DEPLOY' && '5px'};
  width: 100%;
  height: 100%;
  background-color: ${(props: IContainer) => props?.background};
  & > div {
    width: 100%;
  }
  overflow: hidden;
`;

export const MenuItem = styled.div`
  width: 100%;
  padding: 10px;
  &:hover {
    background-color: rgba(167, 182, 194, 0.3);
    cursor: pointer;
    text-decoration: none;
  }
`;

interface IThemeCircle {
  themeProps: any;
}

export const ThemeCircle = styled.div`
  width: 0;
  height: 0;
  border-bottom: 10px solid ${(props: IThemeCircle) => props.themeProps.background};
  border-top: 10px solid ${(props: IThemeCircle) => props.themeProps.headers};
  border-left: 10px solid ${(props: IThemeCircle) => props.themeProps.primary};
  border-right: 10px solid ${(props: IThemeCircle) => props.themeProps.secondary};
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
`;

export const StyledMainNavBarVSelectFieldContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  & > .bp3-form-group {
    margin: 0;
  }
`;

export const IconCollapseMenu = styled(VIcon)`
  cursor: pointer;
`;

export const StyledNotFound404 = styled.div`
  background-color: #396faa;
  width: 100%;
  height: 100vh;
`;

export const StyledNotFound404Header = styled.div`
  display: flex;
  img {
    width: 125px;
    height: 125px;
    margin: 5px;
  }
  @media (max-width: 768px) {
    img {
      width: 100px;
      height: 100px;
    }
  }
`;

export const StyledNotFound404Body = styled.div`
  position: relative;
  max-width: 450px;
  margin: 0 auto;
  padding: 100px 0;
`;

export const StyledNotFound404Text = styled.span`
  color: #fff;
  text-transform: uppercase;

  & div {
    text-transform: none;
    font-size: 16px;
    margin-top: 11px;
    margin-bottom: 62px;
  }

  & span:first-child {
    font-size: 80px;
    font-weight: bold;
    margin: 34%;
  }
  & span:last-child {
    font-size: 25px;
  }

  @media (max-width: 375px) {
    & span:first-child {
      margin: 25%;
    }
    & span:last-child {
      font-size: 25px;
    }
  }
`;

export const AnchorButtonStyle = styled(AnchorButton)`
  border-radius: 18px;
`;

export const NavBarStyle = styled(Navbar)`
  display: flex;

  & > .bp3-align-left {
    flex-basis: 80%;
  }
  & > .bp3-align-right {
    flex-basis: 20%;
    text-align: right;
    justify-content: flex-end;
  }
`;

const addMarginBottom = (isCollapse: boolean) => (isCollapse ? `margin-bottom: 28px;` : '');

type SidebarSearchType = {
  collapse: boolean;
};

export const SidebarSearch = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  ${(props: SidebarSearchType) => addMarginBottom(props.collapse)}
`;

export const SidebarCollapsed = styled(Icon)`
  position: absolute;
  right: -20px;
  top: 0;
  z-index: 11;
  height: 50px;
  justify-content: center;
  align-items: center;

  svg {
    width: 20px;
    height: auto;
  }

  &:hover {
    cursor: pointer;
    background: rgba(167, 182, 194, 0.3);
  }

  &:active svg {
    transform: translateX(${(props: SidebarSearchType) => (props.collapse ? '' : '-')}1px);
  }

  && {
    display: flex;
  }
`;

type NavProps = {
  backgroundColor: string;
};

export const Nav = styled.div`
  background-color: ${(props: NavProps) => props.backgroundColor || '#1e1e23'};
  height: 46px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & div:nth-child(3) {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
`;

interface IMenuToggle {
  onDrawer?: boolean;
}

export const MenuToggle = styled.label`
  display: flex;
  flex-direction: column;
  user-select: none;
  margin-right: 1rem;
  margin-left: 1rem;
  ${(props: IMenuToggle) => props.onDrawer && `position: absolute; top: 20px;`}

  & input {
    display: none;
  }

  & span {
    display: flex;
    width: 29px;
    height: 2px;
    margin-bottom: 5px;
    position: relative;
    background: #ffffff;
    border-radius: 3px;
    transform-origin: 5px 0;
    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
      opacity 0.55s ease;
  }

  & span:first-child {
    transform-origin: 0 0;
  }

  & span:nth-last-child(2) {
    transform-origin: 0 100%;
  }

  & input:checked ~ span {
    opacity: 1;
    transform: rotate(45deg) translate(-9px, -9px);
    background: #ffffff;
  }
  & input:checked ~ span:nth-last-child(3) {
    opacity: 0;
    transform: rotate(0deg) scale(0.2, 0.2);
  }

  & input:checked ~ span:nth-last-child(2) {
    transform: rotate(-45deg) translate(-7px, 9px);
  }

  & input:checked ~ ul {
    transform: none;
  }
`;
